import {
  ClassActivity,
  ClassActivityListItem,
  ClassActivityPluralTypes,
  PreviouslyUsedActivityCourseData,
} from '../class-activities/types';
import { BasePPTOptions, CourseUser, FileAttachment, PollSlideTypes, PublishPreferences } from '../types';

export interface UnpublishedPollItem extends ClassActivityListItem {
  activityType: ClassActivityPluralTypes.POLLS;
  slideType: PollSlideTypes;
}

export interface PollPPTOptions extends BasePPTOptions {
  /** `""` when slide type is not set */
  slideType: PollSlideTypes | '';
}

export interface PreviouslyUsedPollItem extends PreviouslyUsedActivityCourseData<UnpublishedPollItem> {}

export enum PollTypes {
  UNPUBLISHED = 'unpublished',
  PREVIOUSLY_USED = 'previouslyUsed',
}

export interface BasePollOption {
  /** type is always text even when we upload an image */
  type: 'text';
  text: RichText;
}

export interface BasePollOptionWithNum extends BasePollOption {
  /**
   * Option number, starts from `1`
   * used to get stats for an option by matching this property on both
   * */
  num: number;
}

interface PollOption extends BasePollOptionWithNum {
  optionId: string;
  /** total number of students who selected this option */
  totalSelections: number;
}

export interface PollQuestion {
  id: MongoId;
  description: RichText;
  attachments: FileAttachment[];
  options: PollOption[];
  /** total number of students who attempted this poll */
  totalAttempts: number;
}

export interface Poll extends ClassActivity, PollPPTOptions {
  /** Poll publish preferences */
  preferences: PublishPreferences;
  /** `true` when question is created */
  isQuestionSet: boolean;
  /** Array of question-ids to maintain questions order */
  questions: MongoId[];
  /** `null`, means either question is not added or yet to be fetched */
  questionsById: Dictionary<PollQuestion> | null;
  /**
   * `-1` means not accessed by current user, for creator
   * it will be equal to `createdOn`
   */
  firstAccessedOn: UnixTime;
  /** `-1` when not accessed */
  lastAccessedOn: UnixTime;
  createdBy: CourseUser;
  /** number of students who submitted the poll */
  pollSubmissions: number;
}

export enum StudentResponses {
  NOT_ANONYMOUS = 'Not anonymous',
  ANONYMOUS = 'Anonymous',
}
